export default "__VITE_ASSET__BNf0Y6RG__"